import ArrPagination from '../../../components/common/arr-pagination/ArrPagination';
import {useState} from 'react';
import {Link} from 'react-router-dom';
import {Box, Typography} from '@mui/material';

const TextField: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(25);
  const TOTAL_USERS = 210;

  // Reset to page 1 when perPage changes
  const handlePerPageChange = (newPerPage: number) => {
    setPerPage(newPerPage);
    setCurrentPage(1);
  };

  return (
    <Box className=" pagination-demo">
      <Typography component="h1" className="typo-text headline1_size">
        ARR Pagination
      </Typography>

      <Box marginTop={5}>
        <Typography component="h2"> Limited Mode Pagination</Typography>
        <ArrPagination
          perPageSize={[10, 25, 50, 100]}
          totalItems={TOTAL_USERS}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          perPage={perPage}
          onPerPageChange={handlePerPageChange}
          mode="limited"
          entityType="users"
        />
      </Box>

      <Box marginTop={20}>
        <Typography component="h2"> Wide Mode Pagination</Typography>

        <ArrPagination
          perPageSize={[25, 50, 100]}
          totalItems={TOTAL_USERS}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          perPage={perPage}
          onPerPageChange={setPerPage}
          mode="wide"
          entityType="users"
        />
      </Box>
      <Box mt={10}>
        <Link to="/demo/" className="link link-color">
          {' '}
          Return back to demo
        </Link>
      </Box>
    </Box>
  );
};

export default TextField;
